import { FC } from "react";

import { IBirthdayEvent } from "Bands/types";
import { FlexContainer, Icon, MutedDarkText, MutedText } from "shared/styles";
import { colors } from "shared/styles/constants";
import { CalendarListDate } from "shared/components";
import { Cake } from "shared/assets/icons";
import { getMemberName } from "Bands/utils";

interface CalendarListBirthdayProps {
  birthday: IBirthdayEvent;
}

export const CalendarListBirthday: FC<CalendarListBirthdayProps> = ({ birthday }) => {
  return (
    <FlexContainer size="xs" flexWrap="nowrap">
      <CalendarListDate date={birthday.date} />
      <Icon size="m" as={Cake} color={colors.grey4} />
      <MutedText>{getMemberName(birthday)}</MutedText>
      {!!birthday.bands?.length && <MutedDarkText>{birthday.bands.join(", ")}</MutedDarkText>}
    </FlexContainer>
  );
};
